import script from "./DataDisplayPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DataDisplayPage.vue?vue&type=script&setup=true&lang=js"

import "./DataDisplayPage.vue?vue&type=style&index=0&id=d2595a6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2595a6c"]])

export default __exports__